import './products-services-page.scss';
import BasePageLayout from '../../../components/layouts/base-page-layout/base-page-layout';
import { observer } from 'mobx-react';
import { useState } from 'react';
import ShopifySettingsCard from './components/shopify-settings-card/shopify-settings-card';
import integrationListStore from './stores/integrations-list-store';
import { FONT_COLOR, FONT_VARIANT } from '../../../components/fonts/font-props';
import FontBody2 from '../../../components/fonts/font-body2/font-body2';
import IntegrationsList from './components/integrations-list/integrations-list';

interface IProductsServicesPageProps {
}

const ProductsServicesPage: React.FC<IProductsServicesPageProps> = observer(() => {
    const [isAllExpanded, setIsAllExpanded] = useState(false);

    const isExpandable = integrationListStore.integrations && integrationListStore.integrations.length >= 1;

    return (
        <BasePageLayout title="Settings" subTitles={['Integrations', 'Products & Services']} 
            instruction={'Integrate your ReturnGO account with additional products and services to streamline your work.'}>
            <div className='products-services-page'>
                {isExpandable && 
                    <div className='expand-collapse' onClick={() => setIsAllExpanded(!isAllExpanded)}>
                        <FontBody2 variant={FONT_VARIANT.DASHED} color={FONT_COLOR.PRIMARY3}>{isAllExpanded ? 'Collapse all' : 'Expand all'}</FontBody2>
                    </div>
                }
                <ShopifySettingsCard isExpandable={true} isExpanded={isAllExpanded} />
                <IntegrationsList isExpanded={isAllExpanded} />
            </div>
        </BasePageLayout>
    );
});

export default ProductsServicesPage;
